import { render, staticRenderFns } from "./ModifyStep1.vue?vue&type=template&id=51bc8c97&scoped=true&"
import script from "./ModifyStep1.vue?vue&type=script&lang=js&"
export * from "./ModifyStep1.vue?vue&type=script&lang=js&"
import style0 from "./ModifyStep1.vue?vue&type=style&index=0&id=51bc8c97&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc8c97",
  null
  
)

export default component.exports